/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResetPasswordBody
 */
export interface ResetPasswordBody {
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordBody
     */
    verificationCode: string;
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordBody
     */
    newPassword: string;
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordBody
     */
    confirmPassword: string;
}

/**
 * Check if a given object implements the ResetPasswordBody interface.
 */
export function instanceOfResetPasswordBody(value: object): value is ResetPasswordBody {
    if (!('verificationCode' in value) || value['verificationCode'] === undefined) return false;
    if (!('newPassword' in value) || value['newPassword'] === undefined) return false;
    if (!('confirmPassword' in value) || value['confirmPassword'] === undefined) return false;
    return true;
}

export function ResetPasswordBodyFromJSON(json: any): ResetPasswordBody {
    return ResetPasswordBodyFromJSONTyped(json, false);
}

export function ResetPasswordBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResetPasswordBody {
    if (json == null) {
        return json;
    }
    return {
        
        'verificationCode': json['verificationCode'],
        'newPassword': json['newPassword'],
        'confirmPassword': json['confirmPassword'],
    };
}

export function ResetPasswordBodyToJSON(json: any): ResetPasswordBody {
    return ResetPasswordBodyToJSONTyped(json, false);
}

export function ResetPasswordBodyToJSONTyped(value?: ResetPasswordBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'verificationCode': value['verificationCode'],
        'newPassword': value['newPassword'],
        'confirmPassword': value['confirmPassword'],
    };
}

